import { HttpClient } from '@/core/http/http-client';
import { User } from '../domain';
import { mapUser } from '../mappers';
import { ApiResponseUser, UserJson } from '../types';

export class UserRepository {
  constructor(private readonly client: HttpClient) {}

  async getCurrentUser(): Promise<User> {
    const response = await this.client.get<ApiResponseUser<UserJson>>({
      url: `/me`,
    });

    return mapUser(response?.data.user);
  }

  async linkCurrentUser(): Promise<boolean> {
    await this.client.post({
      url: '/me/link',
    });

    return true;
  }
}
